/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Wizard_FinishInputs */



/**
* | output |
* | --- |
* | "Finish" |
*
* @param {My_Integrations_Wizard_FinishInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_wizard_finish = /** @type {((inputs?: My_Integrations_Wizard_FinishInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Wizard_FinishInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fertigstellen")
	return /** @type {LocalizedString} */ ("Finish")
});